import React from 'react';
import styled from 'styled-components';

/**
 * Renders an SVG imported with `*.svg?react` (SVGR) so paths are real DOM — not `mask-image`
 * (which often shows as a solid square with bundled SVG URLs in Chrome).
 * Parent menu `color` tints strokes via `currentColor`.
 */
const IconSvgWrap = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: inherit;
    line-height: 0;
    & > svg {
        display: block;
        width: 100%;
        height: 100%;
    }
    & svg path,
    & svg circle,
    & svg ellipse,
    & svg line,
    & svg polyline,
    & svg polygon,
    & svg rect {
        stroke: currentColor !important;
    }
    & svg path[fill]:not([fill='none']):not([fill='transparent']),
    & svg circle[fill]:not([fill='none']):not([fill='transparent']),
    & svg rect[fill]:not([fill='none']):not([fill='transparent']) {
        fill: currentColor !important;
    }
`;

export function SidebarIconSvg({ Icon, size = 20, className, style, ...rest }) {
    if (!Icon) return null;
    return (
        <IconSvgWrap
            className={className}
            style={{
                width: size,
                height: size,
                ...style,
            }}
            aria-hidden
            {...rest}
        >
            <Icon width={size} height={size} aria-hidden />
        </IconSvgWrap>
    );
}
